// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {VTPSet} from "@models";
import {SimVopSetService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-vop-chip-input",
	templateUrl: "./sim-vop-chip-input.component.html",
	styleUrls: ["./sim-vop-chip-input.component.scss"],
	standalone: false,
})
export class SimVopChipInputComponent {
	@Input() vopSetFc: FormArray<FormControl<VTPSet>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleVopSets = false;

	optionSelected = output<VTPSet>();

	autoCompleteData: VMAutoCompleteNormal<VTPSet>[] = [];

	constructor(private _simVTPService: SimVopSetService) {}

	reloadAutoCompleteData(searchString: string) {
		this._simVTPService.listVOPSets(searchString, "Name", true, 0, 20).then((vopSets) => {
			this.autoCompleteData = vopSets.data.map((v) => ({
				displayName: v.name,
				value: v,
			}));
		});
	}
}
